import moment from 'moment'
import { FC } from 'react'

import { WizardDataStatusInterface } from 'src/types/WizardDataStatusInterface'
import { WIZARD } from 'src/utils/constant'
import WizardStatusContent from './WizardStatusContent'

import * as styles from './WizardContent.scss'

interface WizardStatusProps {
  dashboards: WizardDataStatusInterface[]
}

const ALL_AVAILABLE = 'all_ok'

const WizardStatus: FC<WizardStatusProps> = ({ dashboards }) => {
  const newDashboard = dashboards.filter(el => el.type !== ALL_AVAILABLE)

  const dateStatus = moment().subtract(1, 'days').format('MMMM Do')

  return (
    <div className={styles.ContentSection}>
      <div className={styles.ContentSectionTitle}>
        <p>{WIZARD.title_availability}</p>
        <p className={styles.ContentSectionTitleDescription}>Data status for {dateStatus}</p>
      </div>
      <WizardStatusContent dashboards={newDashboard} />
    </div>
  )
}

export default WizardStatus
